import { FormContainer, Message } from '../../components'
import { useForm } from 'react-hook-form'
import { useParams, Link,useNavigate } from 'react-router-dom'
import { inputPassword } from '../../utils/dynamicForm'
import { useState } from 'react'
import useAuthHook from '../../api/auth'
import { Helmet } from 'react-helmet'
import { AiOutlineKey , AiOutlineHome  } from "react-icons/ai"

const ResetPassword = () => {
  const { postResetPassword } = useAuthHook()
  const param = useParams()
  const navigate = useNavigate()

  const { resetToken } = param
  var [remainingTime, setRemainingTime] = useState(5)

  const {
    register,
    handleSubmit,
    watch,
    //reset: resetForm,
    formState: { errors },
  } = useForm({
    defaultValues: {
      admin: false,
      user: false,
    },
  })

  const { isLoading, isError, error, isSuccess, mutateAsync } = postResetPassword




  const submitHandler = async (data) => {
    const password = data.password
    var retorno = await mutateAsync({ password, resetToken })
    if (retorno.message) {
      let count = 5
      let interval = setInterval(() => {
          setRemainingTime(
            (prevRemainingTime) =>
              prevRemainingTime > 0 ? prevRemainingTime - 1 : 0 // Reduce por 1 segundo
          ), count = count - 1, count == 0 ? navigate('/auth/login') : '', count == 0 ? clearInterval(interval) : ''
        }, 1000)
    }

  }

  function millisToMinutesAndSeconds(millis) {
    var minutes = Math.floor(millis / 60000);
    var seconds = ((millis % 60000) / 1000).toFixed(0);
    return minutes + ":" + (seconds < 10 ? "0" : "") + seconds;
  }

  return (
    <FormContainer>
      <Helmet>
        <title>Resetear Contraseña</title>
        <meta property='og:title' content='Resetear' key='title' />
      </Helmet>
      <center><h3 className=''>Resetear Contraseña</h3></center>
      {isSuccess && (
        <Message variant='success'>Contraseña actualizada exitosamente. Se redireccionará en <b>{millisToMinutesAndSeconds(remainingTime * 1000)}</b> segundos a la página de inicio para que acceda al sistema.</Message>
      )}

      {isError && <Message variant='danger'>{error}</Message>}

    
      <form onSubmit={handleSubmit(submitHandler)}>
      
        <div className='row'>
          <div className="alert alert-primary" role="alert">
            Ingrese los valores requeridos para realizar el proceso de cambio de contraseña.
            Mínimo 6 caracteres, al menos 1 letra minúscula, 1 letra mayúscula y 1 número<br></br>
            <b>No se permiten caracteres especiales cómo: +,-,$,*,/,_,etc</b>
          </div>
        </div>
        <div className='row'>
          <div className='col-md-2'></div>
          <div className='col-md-8'>
            {inputPassword({
              register,
              errors,
              label: 'Contraseña',
              name: 'password',
              minLength: true,
              isRequired: true,
              placeholder: 'Contraseña',
            })}    
          </div>
          <div className='col-md-2'></div>
        </div>
        <div className='row'>
          <div className='col-md-2'></div>
          <div className='col-md-8'>
            {inputPassword({
              register,
              errors,
              watch,
              name: 'confirmPassword',
              label: 'Confirmar Contraseña',
              validate: true,
              minLength: true,
              placeholder: 'Confirmar Contraseña',
            })}  
          </div>
          <div className='col-md-2'></div>
        </div>
       <br></br>
        <div className='row'>
          <div className='col-md-6'>
          <button
              type='submit'
              className='btn btn-primary form-control '
              disabled={isLoading}
            >
              {isLoading ? (
                <span className='spinner-border spinner-border-sm' />
              ) : (
                ''
              )} <AiOutlineKey  /> &nbsp; Cambiar
            </button>
          </div>
          <div className='col-md-6'>
            <Link to='/auth/login' className='btn btn-primary form-control' >
              <AiOutlineHome /> &nbsp;    Retornar Página Inicio
            </Link>
          </div>    
        </div> 

      </form>

    </FormContainer>
  )
}

export default ResetPassword
